










import { invalid } from "moment";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class extends Vue {
	@Prop() public chips: string[];
	public currentInput: string = "";
	public invalid: boolean = false;

	saveChip() {
		if(this.currentInput.trim().length > 0) {
			if(this.validateEmail(this.currentInput)) {
				this.invalid = false;
				this.chips.push(this.currentInput);
				this.currentInput = '';
				this.$emit("change", this.chips);
				this.$emit("valid");
			}
			else {
				this.invalid = true;
				this.$emit("invalid");
			}
		}
		else {
			this.invalid = false;
		}
	}
	deleteChip(index: number) {
		this.chips.splice(index, 1);
		this.$emit("change", this.chips);
		if(this.chips.length === 0) this.invalid = false;
	}
	backspaceDelete({which}: any) {
		which == 8 && this.currentInput === '' && this.chips.splice(this.chips.length - 1);
		this.$emit("change", this.chips);
		if(this.chips.length === 0) this.invalid = false;
	}
	onKeyup({key}: any) {
		if(key === ';' || key === ',' || key === ' ') {
			this.currentInput = this.currentInput.slice(0, -1);
			this.saveChip();
		}
	}

	public validateEmail(email: string): boolean {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Email regex pattern
		return emailRegex.test(email);
	}
}
